import { setGlobalContext } from '@modern-js/runtime/context';
let appConfig;
let appInit;
let layoutApp;

    import { routes } from './routes';

    const entryName = 'main';
      setGlobalContext({
        entryName,
        layoutApp,
        routes,
        appInit,
        appConfig,
        enableRsc: false,
      });
    